/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class RecipientDto {
  emails: Array<string>;
  mobiles: Array<string>;
}
